module.exports = __webpack_public_path__ + "static/media/campus-mobile-claro.e07b7fb4.webp";